import { Component } from '@angular/core';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams } from 'ag-grid-enterprise';

type DropdownFilterComponentParams = IFloatingFilterParams & {
  options: { value: string; label: string }[];
};

@Component({
  selector: 'app-dropdown-floating-filter',
  imports: [],
  templateUrl: './dropdown-floating-filter.component.html',
  styleUrl: './dropdown-floating-filter.component.scss',
})
export class DropdownFloatingFilterComponent
  implements IFloatingFilterAngularComp
{
  options: { value: string; label: string }[] = [];
  params!: DropdownFilterComponentParams;
  value: string | null = null;

  agInit(params: DropdownFilterComponentParams): void {
    this.options = params.options;
    this.params = params;
  }
  onParentModelChanged(parentModel: unknown): void {
    if (
      parentModel &&
      typeof parentModel === 'object' &&
      'filter' in parentModel &&
      (typeof parentModel.filter === 'string' ||
        parentModel.filter === null ||
        parentModel.filter === undefined)
    ) {
      this.value = parentModel.filter ?? null;
    } else {
      this.value = null;
    }
  }

  getModel() {
    return { filter: this.value };
  }

  onChange(event: Event) {
    const target = event.target;
    if (!target) {
      return;
    }
    const select = target as HTMLSelectElement;
    this.value = select.value || null;
    this.params.parentFilterInstance(instance =>
      instance.onFloatingFilterChanged(null, this.value),
    );
  }
}
